import type { ComponentProps } from 'react';
import { useMemo } from 'react';
// components
import HubiversePropertySelect from 'components/Selects/HubiversePropertySelect';
import type { TFormFieldUpdater } from '../FormFieldUpdater';
import FormFieldUpdater from '../FormFieldUpdater';
// types
import { useAppDispatch } from 'rtk/query/hooks';
import { type TFormSubType } from '@hubertai/screening-question-types';
import { updateFormHubiverseProperty } from 'rtk/Question.Editor.Slice';
import { useQuestionEditorContext } from 'components/Questionsv2/builder/context/create-question.context';
import { useTranslation } from 'react-i18next';

interface Props extends ComponentProps<'div'> {
  form: TFormSubType;
  formIndex: number;
}

const CreateFormNumber = ({ form, formIndex, ...props }: Props) => {
  const { t } = useTranslation('Questionsv2');
  const { questionId } = useQuestionEditorContext();
  const dispatch = useAppDispatch();

  const formFieldValues: TFormFieldUpdater[] = useMemo(
    () => [
      {
        label: t('form.number.placeholder.label'),
        description: t('form.number.placeholder.description'),
        formKey: 'placeholder',
        fieldType: 'text',
        formValuesKey: 'placeholder',
        form,
        formIndex,
      },
      {
        label: t('form.number.min.label'),
        description: t('form.number.min.description'),
        formKey: 'min',
        fieldType: 'number',
        formValuesKey: 'min',
        form,
        formIndex,
      },
      {
        label: t('form.number.max.label'),
        description: t('form.number.max.description'),
        formKey: 'max',
        fieldType: 'number',
        formValuesKey: 'max',
        form,
        formIndex,
      },
      {
        label: t('form.number.step.label'),
        description: t('form.number.step.description'),
        formKey: 'step',
        fieldType: 'number',
        formValuesKey: 'step',
        form,
        formIndex,
      },
    ],
    [t, form, formIndex],
  );

  return (
    <div {...props}>
      {formFieldValues.map((x, index) => {
        return (
          <FormFieldUpdater
            key={`form-field-updater-${form.id}-${index}`}
            label={x.label}
            description={x.description}
            formKey={x.formKey}
            fieldType={x.fieldType}
            formValuesKey={x.formValuesKey}
            form={x.form}
            formIndex={x.formIndex}
          />
        );
      })}

      <HubiversePropertySelect
        selected={form.candidate_property ?? ''}
        onSelect={(e: string) => {
          dispatch(updateFormHubiverseProperty({ questionId, formIndex, value: e }));
        }}
        includeLabel={true}
      />
    </div>
  );
};

export default CreateFormNumber;
